import { enableProdMode, LOCALE_ID, ErrorHandler, importProvidersFrom } from '@angular/core';

import * as Sentry from '@sentry/browser';

import 'hammerjs';
import { HammerConfig } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { AmTripsAddProductModule } from '@am/trips-add-product';
import { ParamsSerializer } from '@store/router/router-serializer';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { AppRoutingModule } from './app/app-routing.module';
import { ContextEffects } from '@store/context/context.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers, metaReducers } from '@store/index';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from './app/shared/shared.module';

import { CoreModule } from './app/core/core.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppErrorHandler } from './app/error-handler';
import {
  HAMMER_GESTURE_CONFIG,
  BrowserModule,
  HammerModule,
  bootstrapApplication,
} from '@angular/platform-browser';
import { DatePipe } from '@angular/common';

const runtimeChecksCustom = !environment.production
  ? {
      strictActionSerializability: true,
      strictActionTypeUniqueness: true,
      strictActionWithinNgZone: true,
      strictStateSerializability: true,
    }
  : {};

if (environment.production) {
  enableProdMode();
}

if (environment.sentry.enabled) {
  Sentry.init({
    enabled: true,
    dsn: environment.sentry.dsn,
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      CoreModule,
      SharedModule,
      HammerModule,
      StoreModule.forRoot(reducers, {
        metaReducers,
        runtimeChecks: {
          ...runtimeChecksCustom,
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }),
      !environment.production ? StoreDevtoolsModule.instrument() : [],
      EffectsModule.forRoot([ContextEffects]),
      AppRoutingModule,
      StoreRouterConnectingModule.forRoot({
        serializer: ParamsSerializer,
      }),
      AmTripsAddProductModule,
    ),
    { provide: LOCALE_ID, useValue: 'es-AR' },
    DatePipe,
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    {
      provide: 'analytics-category-token',
      useValue: 'HTL|Results',
    },
    {
      provide: 'autocomplete-base-token',
      useValue: '/autocomplete',
    },
    {
      provide: 'destination-base-token',
      useValue: '/api/destination',
    },
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
